const defaultState = {loading:false};

export default function loading(state=defaultState, action) {
    switch(action.type) {
        case 'ShowLoading':
            return { ...action.data };
        case 'HideLoading':
            return { ...action.data };
        default:
            return state;
    }
}